import { useTranslation } from '@klaviyo-mkt/components/hooks/useTranslation';

import type { IUniversalMenuItemCTA } from '@klaviyo-mkt/components/shared/types';

export const useHelpCenterCTAData = () => {
  const { t, i18n } = useTranslation();

  const ctas = [
    {
      id: t('navigation_ecosystem_ctas_contactUs_label'),
      label: t('navigation_ecosystem_ctas_contactUs_label'),
      locale: i18n.language,
      url: t('navigation_ecosystem_ctas_contactUs_href'),
      variant : 'primary',
    },
  ] satisfies IUniversalMenuItemCTA[];

  return ctas;
};
